// Файл FileIcon.js

/**
 * Компонент сопоставляет расширение файла с компактной визуальной меткой типа вложения.
 */

const file_styles = {
    pdf: { class_name: 'pdf', color: '#e05a4b', label: 'PDF' },
    doc: { class_name: 'docx', color: '#2b579a', label: 'DOC' },
    docx: { class_name: 'docx', color: '#2b579a', label: 'DOC' },
    xls: { class_name: 'xlsx', color: '#1d6f42', label: 'XLS' },
    xlsx: { class_name: 'xlsx', color: '#1d6f42', label: 'XLS' },
    csv: { class_name: 'csv', color: '#2f75b5', label: 'CSV' },
};

const FileIcon = ({ ext }) => {
    const file_style = file_styles[ext];

    if (file_style) {
        return (
            <svg
                className={`doc-card__file-icon doc-card__file-icon--${file_style.class_name}`}
                viewBox="0 0 24 24"
                fill="none"
            >
                <rect
                    x="3" y="1"
                    width="14" height="18"
                    rx="2"
                    fill="#fff"
                    stroke={file_style.color}
                    strokeWidth="1.5"
                />
                <path
                    d="M14 1v5h5"
                    stroke={file_style.color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <rect
                    x="1" y="12"
                    width="16" height="7"
                    rx="1.5"
                    fill={file_style.color}
                />
                <text
                    x="9" y="17.5"
                    textAnchor="middle"
                    fontSize={ext === 'pdf' ? '4.5' : '4'}
                    fontWeight="700"
                    fill="#fff"
                    fontFamily="Arial,sans-serif"
                >
                    {file_style.label}
                </text>
            </svg>
        );
    }

    return (
        <svg
            className="doc-card__file-icon doc-card__file-icon--other"
            viewBox="0 0 24 24"
            fill="none"
        >
            <rect
                x="3" y="1"
                width="14" height="18"
                rx="2"
                fill="#fff"
                stroke="#8a8f98"
                strokeWidth="1.5"
            />
            <path
                d="M14 1v5h5"
                stroke="#8a8f98"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            {[9, 12].map((position) => (
                <line
                    key={position}
                    x1="6" y1={position}
                    x2="14" y2={position}
                    stroke="#8a8f98"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                />
            ))}
            <line
                x1="6" y1="15"
                x2="11" y2="15"
                stroke="#8a8f98"
                strokeWidth="1.2"
                strokeLinecap="round"
            />
        </svg>
    );
};


export default FileIcon;
